import React from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  TeacherImageGalleryPage,
  TeacherLoadingState,
  TeacherPageShell,
  useTeacherAdventureOverview,
} from './teacherAdventureShared';

export const TeacherDangerImagesPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const selectedDate = searchParams.get('date') ?? undefined;
  const selectedLessonRunId = searchParams.get('lessonRunId') ?? undefined;
  const { overview, isLoading, loadError, reloadOverview } = useTeacherAdventureOverview(
    selectedDate,
    selectedLessonRunId
  );
  const [isRefreshing, setIsRefreshing] = React.useState(false);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      await reloadOverview({ silent: true });
    } finally {
      setIsRefreshing(false);
    }
  };

  if (isLoading || loadError) {
    return (
      <TeacherPageShell title="设计惊险情节" description="这里查看学生上传的惊险情节图片。">
        <TeacherLoadingState error={loadError} loadingText="正在加载惊险情节图片..." />
      </TeacherPageShell>
    );
  }

  return (
    <TeacherImageGalleryPage
      title="设计惊险情节"
      description="这里查看学生上传的惊险情节图片。"
      imageLabel="惊险情节"
      records={overview.dangerImageRecords}
      emptyText="当前还没有学生上传惊险情节图片。"
      onRefresh={() => {
        void handleRefresh();
      }}
      isRefreshing={isRefreshing}
    />
  );
};
